// Only the SomethingWentWrongPage namespace is rendered by the global-error
// boundary, so we import that single key per locale (named JSON imports are
// tree-shakeable) instead of pulling the entire message catalog into the client
// error chunk.
import { SomethingWentWrongPage as somethingWentWrongEn } from "../../messages/en.json";
import { SomethingWentWrongPage as somethingWentWrongEnCa } from "../../messages/en-CA.json";
import { SomethingWentWrongPage as somethingWentWrongFrCa } from "../../messages/fr-CA.json";
import { SomethingWentWrongPage as somethingWentWrongJaJp } from "../../messages/ja-JP.json";

// Global error runs as a client boundary and may render without the standard
// locale bootstrap path, so it needs a small self-contained message map.
export const globalErrorMessageBundles = {
  en: { SomethingWentWrongPage: somethingWentWrongEn },
  "en-ca": { SomethingWentWrongPage: somethingWentWrongEnCa },
  "fr-ca": { SomethingWentWrongPage: somethingWentWrongFrCa },
  "ja-jp": { SomethingWentWrongPage: somethingWentWrongJaJp },
} as const;

export const normalizeGlobalErrorLocale = (locale: string | undefined) => {
  if (!locale) return "en";
  const normalized = locale.toLowerCase();

  if (normalized in globalErrorMessageBundles) {
    return normalized as keyof typeof globalErrorMessageBundles;
  }

  if (normalized.startsWith("en")) return "en";
  if (normalized.startsWith("fr")) return "fr-ca";
  if (normalized.startsWith("ja")) return "ja-jp";

  return "en";
};

export const readNextLocaleCookie = () => {
  if (typeof document === "undefined") return undefined;

  const match = /(?:^|;\s*)NEXT_LOCALE=([^;]+)/.exec(document.cookie);
  if (!match?.[1]) return undefined;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};
